import React from 'react'
import { Route } from 'react-router-dom'
import UpdateSuccess from './UpdateSuccess'

import { updateSuccess } from "../../../constants/routePaths"

const UpdateSuccessRoute = [
  <Route
    key="UpdateSuccess"
    exact path={updateSuccess}
    component={UpdateSuccess}
  />,
];

export default UpdateSuccessRoute
